export { default } from './PageHotels.vue'
